// require('../split-imgs/split-imgs.js') 
